import { SelectOption, WithdrawalBeneficiaryDetailTypeMap } from '@tassat/common-definitions';
import { AccountWithdrawalDataRecord } from '@tassat/fred-definitions';

export type WithdrawalInstructionFields = Array<{
    label: string;
    valueProp: string;
    optional?: boolean;
    valueGetter?: (val?: string) => string;
}>;

export type WithdrawalInstructionsDetailsProps = {
    withdrawalInstruction: AccountWithdrawalDataRecord;
    displayComponent?: 'TransactionDetail' | 'Table';
};

export const beneficiaryDetailsOptions: Array<SelectOption> = Object.values(WithdrawalBeneficiaryDetailTypeMap)
    .map((detailType) => ({
        label: detailType.displayValue,
        value: detailType.value
    }));